import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M10.318 3.862c.719.256 1.34.644 1.8 1.13.488.515.818 1.17.823 1.903a2.55 2.55 0 0 1-.315 1.232l1.39 1.359c.094-.086.231-.19.41-.261a1.335 1.335 0 0 1 1.093.025c.32.155.528.416.657.652.247.452.332 1.051.209 1.528a.75.75 0 0 1-1.452-.377.562.562 0 0 0 0-.191.837.837 0 0 0-.033-.145l-9.32 9.072a.75.75 0 0 1-1.055-.008L2.22 17.468a.75.75 0 0 1 .007-1.066l8.723-8.527c.386-.377.494-.711.492-.97-.002-.27-.123-.576-.412-.881-.591-.625-1.778-1.112-3.197-.982a.75.75 0 0 1-.448-1.394c1.27-.745 2.547-1.368 3.818-1.576 1.313-.213 2.6.021 3.828.936.3.223.96.862 1.582 1.477.645.638 1.315 1.318 1.666 1.677.285.29.456.67.49 1.072l.005.05.937-.108a.75.75 0 0 1 .61.21l1.454 1.42a.75.75 0 0 1-.026 1.097l-2.133 1.899a.75.75 0 0 1-.997-1.12l1.532-1.365-.623-.61-1.35.156a.75.75 0 0 1-.833-.682l-.07-.82a.242.242 0 0 0-.068-.15c-.349-.356-1.012-1.03-1.649-1.66-.66-.653-1.229-1.196-1.423-1.34-.878-.654-1.747-.812-2.69-.658a6.002 6.002 0 0 0-1.126.31ZM3.816 16.945l1.248 1.252 7.876-7.666-1.281-1.252-7.843 7.666Z M14 16.5a2.5 2.5 0 0 1 2.5-2.5h3a2.5 2.5 0 0 1 2.5 2.5v3a2.5 2.5 0 0 1-2.5 2.5h-3a2.5 2.5 0 0 1-2.5-2.5v-3Zm2.5-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3Z';
const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const IntegrationsHammerIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'integrationsHammer')) as IconWithRender;

IntegrationsHammerIcon.displayName = 'IntegrationsHammerIcon';
IntegrationsHammerIcon.propTypes = Icon.propTypes;
IntegrationsHammerIcon.renderIcon = (props) => (
  <IntegrationsHammerIcon {...props} />
);
export default IntegrationsHammerIcon;
